import React, { FC } from 'react'
import { Icon, Tooltip } from '@wmgtech/legato'
import { HeaderCountriesListProps } from './HeaderCountriesList.props'
import './HeaderCountriesList.scss'
import { cn } from 'shared/utils'

const HeaderCountriesList: FC<HeaderCountriesListProps> = ({
  options,
  onSelect,
  activeItemId,
  hasSubtitle = false,
}) => {
  return (
    <div className="header-countries-list items-list">
      {options.map(({ value, label, subtitle, tooltip }) => (
        <Tooltip key={value} message={tooltip || ''} placement="top" colorType="dark" triggerOffset={-7}>
          <div>
            <div
              className={cn('items-list__item header-countries-list__item', {
                'items-list__item--checked': value === activeItemId,
                'header-countries-list__item--checked': value === activeItemId
              })}
              onClick={() => onSelect(value)}
              key={value}
            >
              <div className="header-countries-list__item__icon">{value === activeItemId && <Icon name="check" />}</div>
              <span
                className={cn('header-countries-list__title', {
                  'header-countries-list__title--bold': hasSubtitle
                })}
              >
                {label}&nbsp;
              </span>
              <span className="header-countries-list__subtitle"> {subtitle}</span>
            </div>
          </div>
        </Tooltip>
      ))}
    </div>
  )
}

export default HeaderCountriesList
